import { COLORS, newLayout } from '../theme';

export default {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      whiteSpace: 'nowrap',
      minWidth: 'auto',
      paddingTop: 2,
      paddingBottom: 2,
      fontSize: newLayout.fontSize.body2,
      lineHeight: newLayout.lineHeight.body2,
      textTransform: 'none',
      border: '1px solid transparent',
      borderRadius: newLayout.borderRadius.secondary,

      '&&': {
        boxShadow: 'none',
      },

      // sizes

      '&.MuiButton-sizeXs': {
        minHeight: newLayout.heights.xs,
        padding: `0 ${newLayout.spacing.s2}`,
        lineHeight: newLayout.lineHeight.body2,
      },

      '&.MuiButton-sizeSmall': {
        minHeight: newLayout.heights.s,
        paddingRight: newLayout.spacing.s3,
        paddingLeft: newLayout.spacing.s3,
      },

      '&.MuiButton-sizeMedium': {
        minHeight: newLayout.heights.m,
        paddingRight: newLayout.spacing.s4,
        paddingLeft: newLayout.spacing.s4,
      },

      '&.MuiButton-sizeLarge': {
        minHeight: newLayout.heights.l,
        paddingRight: newLayout.spacing.m2,
        paddingLeft: newLayout.spacing.m2,
      },

      // icon button sizes

      '&[class*="MuiButton-sizeIcon"]': {
        padding: 0,
      },

      '&.MuiButton-sizeIconXs': {
        width: newLayout.heights.xs,
        height: newLayout.heights.xs,
        borderRadius: 4,
      },

      '&.MuiButton-sizeIconSmall': {
        width: newLayout.heights.s,
        height: newLayout.heights.s,
      },

      '&.MuiButton-sizeIcon, &.MuiButton-sizeIconMedium': {
        width: newLayout.heights.m,
        height: newLayout.heights.m,
      },

      '&.MuiButton-sizeIconLarge': {
        width: newLayout.heights.l,
        height: newLayout.heights.l,
      },

      // colors

      // NOTE: contained-primary color comes from palette.primary (see themes.js).
      // The rebrand recolors primary buttons via the v2 PrimaryButton wrapper
      // (var(--btn-primary-bg)); bare MUI contained-primary buttons are not
      // rebranded here to avoid a specificity clash with the v2 SecondaryButton,
      // which renders color="primary".

      '&.MuiButton-containedSecondary': {
        backgroundColor: COLORS.kinetikBlack,

        '&:hover': {
          backgroundColor: COLORS.black80,
        },
        '&:active, &.MuiButton-Active': {
          backgroundColor: COLORS.black90,
        },
        '&.Mui-focusVisible': {
          backgroundColor: COLORS.black90,
        },
        '&.Mui-disabled': {
          color: COLORS.white,
          backgroundColor: COLORS.black40,
        },
      },

      '&.MuiButton-outlinedPrimary, &.MuiButton-outlinedSecondary': {
        '&:active, &.MuiButton-Active': {
          backgroundColor: COLORS.white,
          borderColor: 'var(--primary-action-color)',
        },
        '&.Mui-focusVisible': {
          backgroundColor: COLORS.white,
          borderColor: 'var(--primary-action-color)',
        },
        '&.Mui-disabled': {
          color: COLORS.black20,
          borderColor: COLORS.black20,
        },
      },

      // TODO: [v2-trans] Temporarily commented out so not to affect v1 buttons
      // '&.MuiButton-outlinedSecondary': {
      //   backgroundColor: 'transparent',
      // },

      '&.MuiButton-textPrimary': {
        color: COLORS.black60,

        '&:hover': {
          color: COLORS.kinetikBlack,
          backgroundColor: COLORS.black08,
        },
        '&:active, &.MuiButton-Active': {
          color: COLORS.kinetikBlack,
          backgroundColor: 'transparent',
        },
        '&.Mui-focusVisible': {
          color: COLORS.kinetikBlack,
          backgroundColor: 'transparent',
          boxShadow: '0 0 0 1px var(--primary-action-color)',
        },
        '&.Mui-disabled': {
          color: COLORS.black20,
        },
      },

      '&.MuiButton-textSecondary': {
        color: COLORS.black60,

        '&:hover': {
          color: COLORS.kinetikBlack,
          backgroundColor: 'transparent',
        },
        '&:active, &.MuiButton-Active': {
          color: COLORS.kinetikBlack,
          backgroundColor: 'transparent',
        },
        '&.Mui-focusVisible': {
          color: COLORS.kinetikBlack,
          backgroundColor: 'transparent',
        },
        '&.Mui-disabled': {
          color: COLORS.black20,
        },
      },

      // icons

      svg: {
        fontSize: 'inherit',
      },

      '.MuiButton-startIcon': {
        marginRight: newLayout.spacing.s1,
      },

      '.MuiButton-endIcon': {
        marginLeft: newLayout.spacing.s1,
        paddingRight: newLayout.spacing.s1,
      },
    },
  },
  variants: [
    {
      props: { variant: 'delete' },
      style: {
        textTransform: 'none',
        backgroundColor: COLORS.red,
        color: `${COLORS.white} !important`,
        '&:hover': {
          backgroundColor: COLORS.redDark,
        },
      },
    },
    {
      props: { variant: 'icon-error' },
      style: {
        textTransform: 'none',
        backgroundColor: COLORS.white,
        color: `${COLORS.black40} !important`,
        '&:hover': {
          color: COLORS.red,
          backgroundColor: COLORS.redLight,
          svg: {
            path: {
              fill: COLORS.red,
            },
          },
        },
      },
    },
    {
      props: { variant: 'icon-success' },
      style: {
        textTransform: 'none',
        backgroundColor: COLORS.white,
        color: `${COLORS.black40} !important`,
        '&:hover': {
          color: COLORS.green,
          backgroundColor: COLORS.greenLight,
          svg: {
            path: {
              fill: COLORS.green,
            },
          },
        },
      },
    },
    {
      props: { variant: 'tab' },
      style: {
        textTransform: 'none',
        color: `${COLORS.black50} !important`,
        borderBottom: '2px solid transparent',

        '&:hover': {
          color: `${COLORS.kinetikBlack} !important`,
          backgroundColor: 'transparent',
        },

        '&.MuiButton-tab': {
          padding: `${newLayout.spacing.s2} 0`,
        },

        '.MuiChip-root': {
          marginLeft: newLayout.spacing.s2,
        },
      },
    },
    {
      props: { variant: 'tab-active' },
      style: {
        textTransform: 'none',
        color: `${COLORS.kinetikBlack} !important`,
        borderBottom: '2px solid var(--primary-action-color)',
        borderRadius: 0,

        '&:hover': {
          backgroundColor: 'transparent',
        },

        '&.MuiButton-tab-active': {
          padding: `${newLayout.spacing.s2} 0`,
        },

        '.MuiChip-root': {
          marginLeft: newLayout.spacing.s2,
          background: 'var(--primary-action-color)',
          color: COLORS.white,
          border: 0,
        },
      },
    },
  ],
};
